
import React, { useEffect, useState } from 'react';
import aboutimg1 from '../../images/aboutpage/aboutimg3.png';
import aboutimg2 from '../../images/aboutpage/aboutimg.png';
import aboutimg3 from '../../images/aboutpage/aboutimg4.png';
import "./service.css";
import Quatationform from "../formdesign/quoteform";
import aw1 from '../../images/awandwin/aw1.png';
import aw2 from '../../images/awandwin/aw2.png';
import { BiRightArrowAlt } from "react-icons/bi";
import hsimg1 from '../../images/herobanner2.png';
import hsimg2 from '../../images/package2.png';
import hsimg3 from '../../images/pakage1.png';
import serviabt1 from '../../images/service/serviceabt.png';
import port1 from '../../images/service/port1.png';
import port2 from '../../images/service/port2.png';
import port3 from '../../images/service/port3.png';
import port4 from '../../images/service/port4.png';
import port6 from '../../images/service/port6.png';
import port7 from '../../images/service/port7.png';
import port8 from '../../images/service/port8.png';
import port5 from '../../images/service/port5.png';
import success1 from "../../images/success/success (1).png";
import success2 from "../../images/success/success (2).png";
import success3 from "../../images/success/success (3).png";
import success4 from "../../images/success/success (4).png";
import abimg1 from "../../images/c1 (1).png";
import abimg2 from "../../images/c1 (2).png";
import abimg3 from "../../images/c1 (3).png";
import abimg4 from "../../images/c1 (4).png";
import Accordion from '../Home/accordian/Accordion';
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import Testimonial from "../Home/powerfull/powerfull";
import Popup from '../pup/popup';
import { Helmet } from "react-helmet-async";

export default function Diningroom() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [aboutimg1, aboutimg2, aboutimg3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const portfolioimg1 = [port1, port2, port3, port4];
  const duplicatedImages = [...portfolioimg1, ...portfolioimg1];
  const portfolioimg2 = [port5, port6, port7, port8];
  const duplicatedImages2 = [...portfolioimg2, ...portfolioimg2];

  const items = [
    {
      title: 'What dining room interior services does Cedar Interiors offer in Kerala?',
      content: 'We design customized dining room interiors, including dining tables, chairs, sideboards, and partition screens, catering to homes in Cochin, Palakkad, Tiruvalla, and beyond.',
    },
    {
      title: 'Can I customize the dining table and chairs to match my home interiors?',
      content: 'Absolutely! We provide fully customized dining tables and chairs, ensuring they align with your style, space, and functional needs.',
    },
    {
      title: 'What materials do you use for dining room interiors?',
      content: 'We use premium materials such as solid wood, engineered wood, and glass to create durable and elegant dining room furniture.',
    },
    {
      title: 'How long does it take to complete a dining room interior project?',
      content: 'Dining room interior projects are typically completed within 30–45 days, depending on the design complexity and scope.'
    },
    {
      title: 'Do you offer after-sales support for dining room interiors?',
      content: 'Yes, we provide dedicated after-sales support to ensure your dining room remains functional and stylish for years to come.'
    },
    {
      title: 'Do you provide dining room interior services in Tamil Nadu?',
      content: 'Yes, we serve Tamil Nadu, including cities like Coimbatore, with customized dining room interior solutions tailored to your needs.'
    },
  ];

  const [showPopup, setShowPopup] = useState(false); // State to control popup visibility

  const openPopup = () => {
    setShowPopup(true); // Function to open the popup
  };

  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  return (
    <>
      <Helmet>
        <title>Dining Room Interior Designers in Palakkad
        </title>
        <meta name="description" content="Top Dining Room Interior Designers in Palakkad. We create stylish, functional dining rooms that match your vision and lifestyle. 

" />
      </Helmet>
      <div className="service-main">
        <div className="servicehero"></div>
        <div className="servicehero1">
          <div className="servicehero1col">
            <div className="discount">
              <h2 className="header2">
                <span>Dining Room Interior Design Services</span>
              </h2>
              <h5 className="smallhead">Starting from <span>2 Lakhs</span></h5>
            </div>
          </div>
          <div className="servicehero1col">
            <Quatationform />
          </div>
        </div>
        <div className="serviceinterior">
          <div className="serviceinteriorcol sercol1">
            <div className="service-slide">
              {" "}
              <div className='aboutslider'>
                <div className="about-slider-inner">
                  {images.map((src, index) => (
                    <div
                      key={index}
                      className={`h-slide ${index === currentIndex ? 'active' : ''} ${index === (currentIndex - 1 + images.length) % images.length ? 'previous' : ''}`}
                    >
                      <img src={src} alt={`Slide ${index}`} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="serviceinteriorcol sercol2">
            <div className='awardandwinnig'> <h2 className='header2'><span> Elegant Dining Room Interiors</span></h2>
              <h6>Crafted for Your Home</h6>
              <p>Transform your dining space into a hub of elegance and functionality with Cedar Interiors. Our expert designs blend sophistication with practicality, ensuring that every meal becomes a delightful experience. From luxurious dining tables to smart storage, we create interiors tailored to your lifestyle and taste.</p>
              <p>At Cedar Interiors, we specialize in crafting dining room interiors that balance form and function. Whether hosting a formal dinner or enjoying casual family meals, our designs cater to your every need. With bespoke solutions, we bring timeless aesthetics and unmatched comfort to your dining space.</p>

              <div className="awardwiningblurb">
                <div className="blurb">
                  <div className='aw-blurbimg'>
                    <img src={aw2} alt="aw" />
                  </div>
                  <div className="aw-blurbcontent">
                    <h5>Premium Quality</h5>
                    <p>Finest materials ensured</p>
                  </div>
                </div>
                <div className="blurb">
                  <div className='aw-blurbimg'>
                    <img src={aw1} alt="aw" />
                  </div>
                  <div className="aw-blurbcontent">
                    <h5>Innovation
                    </h5>
                    <p>Creative, modern solutions.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hrline-bg">
          <div className="hrline"></div>{" "}
        </div>
        <div className='homeservice'><h2 className="header2">Best Dining Room <span>Interior Designers</span></h2>
          <p>Create the perfect dining ambiance with Cedar Interiors. From stylish dining tables to elegant chairs, sideboards, and partitions, we provide customized solutions that elevate your dining space.</p>
          <div className="hr"></div>
          {/*servicecard*/}
          <div className="homeservicecard">
            <div className="homesercardcol">
              <h5 className="smallhead">Dining Tables</h5>
              <img src={hsimg1} alt="homedesign" />
              <p>Set the stage for memorable meals with our custom-crafted dining tables. Choose from a variety of materials and designs, from solid wood to glass finishes, ensuring your table is both functional and beautiful.</p>
              <button className='btn1' onClick={openPopup}>Get a Quote<span><BiRightArrowAlt /></span></button>
            </div>
            {/*card2*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Chairs</h5>
              <img src={hsimg2} alt="homedesign" />
              <p>Complete your dining experience with ergonomically designed chairs. Offering style and comfort, our chairs are tailored to complement your dining table and overall interior theme.</p>
              <button className='btn1' onClick={openPopup}>Get a Quote<span><BiRightArrowAlt /></span></button>
            </div>
            {/*card32*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Sideboards</h5>
              <img src={hsimg2} alt="homedesign" />
              <p>Add convenience and style to your dining space with our multifunctional sideboards. Ideal for storing dining essentials, these pieces enhance organization while blending seamlessly with your décor.</p>
              <button className='btn1' onClick={openPopup}>Get a Quote<span><BiRightArrowAlt /></span></button>
            </div>
            {/*card32*/}
            <div className="homesercardcol">
              <h5 className="smallhead">Partition Screens</h5>
              <img src={hsimg3} alt="homedesign" />
              <p>Create defined spaces with our elegant partition screens. Designed for both privacy and style, they add a sophisticated touch to open dining areas while maintaining a cohesive flow.</p>
              <button className='btn1' onClick={openPopup}>Get a Quote<span><BiRightArrowAlt /></span></button>
            </div>

          </div>


        </div>
        <div className='serviceabt'>
          <div className="serviceabtinner">
            <div className="serviceabitinnercol1">
              <div className="servblurb">
                <h3>4 Lakh+ Sq. Ft.</h3>
                <p>Projects Successfully Completed</p>
              </div>
              <div className="servblurb">
                <h3>10-Year</h3>
                <p>Trusted Warranty Coverage</p>
              </div>
              <div className="servblurb1">
                <h3 className='smallhead'>Turning Ideas Into Reality</h3>
                <p>Cedar Interiors redefines dining spaces with innovative designs and over two decades of expertise. We craft interiors that bring elegance and functionality to your dining area.</p>
                <button className='btn2' onClick={openPopup}>Get a Quote <span><BiRightArrowAlt /></span></button>
              </div>
            </div>
            <div className="serviceabitinnercol">
              <h2 className="header2">Transform Dining Spaces </h2>
              <h6 className="smallhead">with Elegance</h6>
              <div className="row1">
                <div className="row1col">
                  <p>Experience dining room interiors designed to impress. Cedar Interiors combines bespoke solutions with timeless aesthetics to create spaces perfect for gathering and entertaining.</p>
                </div>
              </div>
              <img src={serviabt1} alt="" />
            </div>
          </div>
        </div>
        <div className='serviceportfolio'>
          <h2 className="header2">Portfolio for <span>Dining Room Interiors</span></h2>
          <p>Explore our curated portfolio of dining room interiors designed to elevate your dining experience.</p>
          <div className="hr"></div>

          <div className="servportfolioinner">
            <div className="carousel-container">
              <div className="logo-carousel">
                {duplicatedImages.map((logo, index) => (
                  <div key={index} className="logo-item">
                    <img src={logo} alt={`logo-${index}`} />
                  </div>
                ))}
              </div>
            </div>
            {/*second*/}
            <div className="carousel-container">
              <div className="logo-carousel1">
                {duplicatedImages2.map((logo, index) => (
                  <div key={index} className="logo-item">
                    <img src={logo} alt={`logo-${index}`} />
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>

        <div className="successstory">
          <div className="success">
            <p className="build-success">The Path to Your Perfect Space</p>
            <h2 className="header2">Our Success Route</h2>
            <p className="sucees-elevate">
              Elevate your spaces with Vedar Designs & Interior Fitouts L.L.C.
              Experience the fusion of your aspirations with our expertise, creating
              interiors that speak volumes. Your space, our dedication.
            </p>
          </div>

          <div className="success-card">
            <div className="sucess-card1">
              <ul class="card-color">
                <li class="item">
                  {" "}
                  <img src={success1} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success2} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success3} alt="" />
                </li>
                <li class="item">
                  {" "}
                  <img src={success4} alt="" />
                </li>
              </ul>
            </div>
            <div className="success-card2">
              <div className="success-col">
                <div className="blurb">
                  <h4>Inspiration
                  </h4>
                  <p>
                    We start by drawing inspiration from your vision and lifestyle, ensuring every detail reflects your unique taste.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Planning</h4>
                  <p>
                    Strategizing and mapping out the perfect balance of form and function to bring your ideas to life.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Craftsmanship</h4>
                  <p>
                    Bringing designs to reality through innovative techniques and skilled artistry for flawless interiors.
                  </p>
                </div>
              </div>
              <div className="success-col">
                <div className="blurb">
                  <h4>Delivery</h4>
                  <p>
                    Completing your dream space with precision, on-time execution, and uncompromised quality.
                  </p>
                </div>
              </div>
            </div>

            {/* mobile*/}

            <div className="success-card-mob">
              <div class="item">
                {" "}
                <img src={success1} alt="" />
                <div className="blurb">
                  <h4>INSPIRATION</h4>
                  <p>
                    We start by drawing inspiration from your vision and lifestyle, ensuring every detail reflects your unique taste.
                  </p>
                </div>
              </div>



              <div class="item">
                {" "}
                <img src={success2} alt="" />
                <div className="blurb">
                  <h4>PLANNING</h4>
                  <p>
                    Strategizing and mapping out the perfect balance of form and function to bring your ideas to life.
                  </p>
                </div>
              </div>

              <div class="item">
                {" "}
                <img src={success3} alt="" />
                <div className="blurb">
                  <h4>CRAFTSMANSHIP</h4>
                  <p>
                    Bringing designs to reality through innovative techniques and skilled artistry for flawless interiors.
                  </p>
                </div>
              </div>

              <div class="item">
                {" "}
                <img src={success4} alt="" />
                <div className="blurb">
                  <h4>DELIVERY</h4>
                  <p>
                    Completing your dream space with precision, on-time execution, and uncompromised quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="aboutchoose">
          <div className="aboutchoosrow1">
            <div className="aboutchooserow1col col1">
              <h2 className="header2">Cedar Assurance</h2>
              <p>
                Cedar Assurance is our promise to make your interior journey seamless and stress-free. We go beyond delivering beautiful spaces by ensuring every detail reflects quality, precision, and care. With our unwavering commitment to innovation and client satisfaction, Cedar Interiors stands as your trusted partner in creating timeless spaces that inspire.
              </p>
            </div>
            <div className="aboutchooserow1col col2">
              <div className="yofexp">
                <p>45</p>
                <span>Days</span>
                <span>Delivery</span>
              </div>

              <div className="yofexp">
                <p>4Lakh</p>
                <span>SqFt</span>
                <span>Developed</span>
              </div>
              <div className="yofexp">
                <p>10</p>
                <span>Years</span>
                <span>Warranty</span>
              </div>
            </div>
          </div>

          <div className="about-card">
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg1} alt="" />
                <h4>45 Days Delivery</h4>
                <p>
                  Enjoy fast and reliable interior solutions for your new home with our guaranteed 45-day delivery. Your dream home, delivered on time.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg2} alt="" />
                <h4>Design Experts</h4>
                <p>
                  Collaborate with our skilled designers to explore premium ideas and co-create interiors that match your unique style and vision.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg3} alt="" />
                <h4>Aftercare Service</h4>
                <p>
                  Experience uninterrupted support with our dedicated customer care team, ensuring your interiors remain flawless even after project completion.
                </p>
              </div>
            </div>
            <div className="about1-col">
              <div className="blurb">
                <img src={abimg4} alt="" />
                <h4>10-Year Warranty</h4>
                <p>
                  Benefit from high-quality materials and craftsmanship backed by a 10-year warranty for a defect-free and lasting experience.
                </p>
              </div>
            </div>
          </div>

        </div>

        <div>
          {" "}
          <Testimonial />
        </div>


        <div className='accordian faq-layout'>
          <div className="accordian-col">
            <p className='qa'>QUESTIONS & ANSWERS</p>
            <h2 className='header2'>Let us help you find clarity</h2>
            <p className='qa-exp'>
              We’re here to answer your queries and guide you through every step of your journey with us. Explore our frequently asked questions below.
              {/* <br /><br />
          Experience the ultimate getaway at our luxurious resort,
          where every detail is designed to offer. */}
            </p>
          </div>

          <div className="accordian-col">
            {/* Place the Accordion component here */}
            <Accordion items={items} />
          </div>
        </div>
        <Popup showPopup={showPopup} closePopup={closePopup} />
      </div>

    </>
  )
}

